import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";

// GET VEHICULOS PPF
export const getPublicVehiculosPPF = async(token) => {
    const result = await PublicInterceptor(`Logistica/Vehiculos/VehiculosPPF`, 'GET',{}, token)
    return result;
}